import api from './api';

const homeService = {
  // Récupérer toutes les formules d'abonnement actives pour la page d'accueil
  getSubscriptionPlans: async () => {
    try {
      const response = await api.get('/formules/actives');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des formules d\'abonnement:', error);
      throw error;
    }
  }
};

export { homeService };

